module.exports = __webpack_public_path__ + "img/liushui (10).c799f8b2.png";